import { render, staticRenderFns } from "./select_exercise.vue?vue&type=template&id=5e057f64&scoped=true"
import script from "./select_exercise.vue?vue&type=script&lang=js"
export * from "./select_exercise.vue?vue&type=script&lang=js"
import style0 from "./select_exercise.vue?vue&type=style&index=0&id=5e057f64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e057f64",
  null
  
)

export default component.exports